/* eslint-disable react/no-unescaped-entities */
import Head from 'next/head';
import React from 'react';
const LicenseAgreement = () => {
  return (
    <>
      <Head>
        <meta name="og:title" content={'License Agreement - See Sight Tours'} />
        <meta
          name="og:description"
          content={'The License Agreement Of See Sight Tours'}
        />
        <title>License Agreement - See Sight Tours</title>
        <meta
          name="description"
          content={'The License Agreement Page Of See Sight Tours'}
        />
        <link
          rel="canonical"
          href={'https://www.seesight-tours.com/license-agreement'}
        />
        <meta name="og:image" content="/vertical-seesight-logo.png" />
      </Head>
      <div className="py-8 px-2 w-full">
        <div className="flex justify-center items-center">
          <h2 className="px-8 text-lg flex justify-center lg:text-2xl font-bold">
            See Sight Tours End User License Agreement
          </h2>
        </div>
        <div className="px-8 lg:px-28 flex flex-col justify-start">
          <div className="flex flex-col gap-3  mt-6">
            <h2 className="text-[16px] md:text-[18px]  font-bold">
              End User License Agreement
            </h2>
            <p className="text-base text-justify">
              This End User License Agreement ("Agreement") is a legal agreement
              between you ("User" or "You") and See Sight Tours Inc ("Company"
              or "We") governing your use of the See Sight Tours and See Sight
              Tours Goat App mobile applications (collectively referred to as
              the “See Sight Tours Platform”). By downloading, installing,
              accessing, or using the Apps, you agree to be bound by the terms
              and conditions of this Agreement. If you do not agree to these
              terms, do not use the Apps.
            </p>
          </div>
          <div className="flex flex-col gap-3  mt-6">
            <h2 className="text-[16px] md:text-[18px]  font-bold">
              1. License Grant
            </h2>
            <p className="text-base text-justify">
              a. <strong>Limited License:</strong> Subject to the terms and
              conditions of this Agreement, See Sight Tours Inc grants you a
              limited, non-exclusive, non-transferable, revocable license to
              download, install, and use the See Sight Tours and See Sight Tours
              Goat App mobile applications (collectively referred to as the "See
              Sight Tours Platform") solely for your personal, non-commercial
              purposes.
            </p>
            <p className="text-base text-justify">
              b. <strong>Scope of Use:</strong> This license permits you to use
              the Apps on compatible devices that you own or control and solely
              for the purpose of accessing and utilizing the features and
              functionalities provided by the Apps.
            </p>
            <p className="text-base text-justify">
              c. <strong>Restrictions:</strong> You may not:
            </p>
            <div className="ml-5">
              <p className="text-base text-justify">
                i. Modify, copy, reproduce, distribute, sell, lease, sublicense,
                or otherwise transfer the Apps or any part thereof.
              </p>
              <p className="text-base text-justify">
                ii. Reverse engineer, decompile, disassemble, or attempt to
                derive the source code of the Apps, except as expressly
                permitted by applicable law.{' '}
              </p>
              <p className="text-base text-justify">
                iii. Use the Apps in any unlawful manner, for any unlawful
                purpose, or in any manner inconsistent with this Agreement.{' '}
              </p>
            </div>
            <p className="text-base text-justify">
              d. <strong>Reservation of Rights:</strong> See Sight Tours Inc
              reserves all rights not expressly granted to you under this
              Agreement. The license granted herein does not include any rights
              to intellectual property owned by See Sight Tours Inc or third
              parties.
            </p>
            <p className="text-base text-justify">
              e. <strong> No Implied Licenses: </strong> No license or right is
              granted by implication, estoppel, or otherwise except as expressly
              provided in this Agreement.
            </p>
            <p className="text-base text-justify">
              f. <strong> Ownership: </strong> You acknowledge and agree that
              See Sight Tours Inc owns all rights, title, and interest in and to
              the Apps, including all intellectual property rights therein. You
              agree not to remove, alter, or obscure any copyright, trademark,
              or other proprietary notices displayed in or on the Apps.
            </p>
            <p className="text-base text-justify">
              g. <strong> Termination of License: </strong> This license is
              effective until terminated by either party. See Sight Tours Inc
              may terminate this license at any time without notice if you
              breach any provision of this Agreement. Upon termination, you must
              cease all use of the Apps and delete all copies thereof from your
              devices.
            </p>
            <p className="text-base text-justify">
              h. <strong> Updates and Upgrades: </strong> See Sight Tours Inc
              may from time to time provide updates, upgrades, or new versions
              of the Apps. Your continued use of the Apps after such updates
              constitutes acceptance of the updated terms and conditions.
            </p>
          </div>

          <div className="flex flex-col gap-3  mt-6">
            <h2 className="font-bold text-[16px] md:text-[18px] ">
              2. Restrictions
            </h2>
            <p className="text-base text-justify">
              a. <strong> Prohibited Actions:</strong> You may not:
            </p>
            <div className="ml-5">
              <p className="text-base text-justify">
                i. Modify, adapt, translate, reverse engineer, decompile,
                disassemble, or otherwise attempt to derive the source code of
                the Apps, except as expressly permitted by applicable law.
              </p>
              <p className="text-base text-justify">
                ii. Remove, alter, or obscure any copyright, trademark, or other
                proprietary notices displayed in or on the Apps.
              </p>
              <p className="text-base text-justify">
                iii. Use the Apps in any manner that violates any applicable
                laws or regulations, including but not limited to copyright
                laws, privacy laws, and export control laws.{' '}
              </p>
              <p className="text-base text-justify">
                iv. Use the Apps for any unlawful or fraudulent purpose, or to
                engage in any activity that infringes upon the rights of others,
                including but not limited to copyright infringement, trademark
                infringement, or unauthorized access to third-party systems or
                data.
              </p>
              <p className="text-base text-justify">
                v. Transmit, distribute, or upload any content or materials that
                are unlawful, defamatory, libelous, obscene, pornographic,
                indecent, harassing, threatening, abusive, inflammatory, or
                otherwise objectionable.
              </p>
              <p className="text-base text-justify">
                vi. Use the Apps to transmit or distribute any viruses, worms,
                trojan horses, or other malicious code or harmful components
                that could damage, disable, or impair the operation of the Apps
                or any other systems or devices.
              </p>
            </div>
            <p className="text-base text-justify">
              b. <strong> Use Restrictions:</strong> You may not:
            </p>
            <div className="ml-5">
              <p className="text-base text-justify">
                i. Use the Apps for any commercial purpose without the prior
                written consent of See Sight Tours Inc.
              </p>
              <p className="text-base text-justify">
                ii. Use the Apps to impersonate any person or entity, or to
                falsely state or misrepresent your affiliation with any person
                or entity.
              </p>
              <p className="text-base text-justify">
                iii. Use the Apps to collect, store, or disclose personal
                information or data of other users without their consent.
              </p>
              <p className="text-base text-justify">
                iv. Use the Apps in a manner that interferes with or disrupts
                the operation of the Apps, or that could damage, disable, or
                impair the availability or accessibility of the Apps to other
                users.
              </p>
            </div>
            <p className="text-base text-justify">
              c. <strong>Compliance with Laws:</strong> You agree to use the
              Apps in compliance with all applicable laws, regulations, and
              industry standards, including but not limited to copyright laws,
              privacy laws, and data protection laws.
            </p>
            <p className="text-base text-justify">
              d. <strong> Reservation of Rights:</strong> See Sight Tours Inc
              reserves all rights not expressly granted to you under this
              Agreement. Any unauthorized use of the Apps or violation of these
              restrictions may result in the termination of your license and may
              subject you to legal consequences.
            </p>
          </div>

          <div className="flex flex-col gap-3  mt-6">
            <h2 className="text-[16px] md:text-[18px]  font-bold">
              3. Intellectual Property Rights
            </h2>
            <p className="text-base text-justify">
              a. <strong>Ownership of Apps:</strong> The See Sight Tours and See
              Sight Tours Goat App mobile applications (collectively referred to
              as the "See Sight Tours Platform") and all content, features, and
              functionality thereof are owned by See Sight Tours Inc and are
              protected by copyright laws and international treaties.
            </p>
            <p className="text-base text-justify">
              b. <strong>License Grant:</strong> Subject to the terms and
              conditions of this Agreement, See Sight Tours Inc grants you a
              limited, non-exclusive, non-transferable, revocable license to
              download, install, and use the Apps solely for your personal,
              non-commercial purposes.
            </p>
            <p className="text-base text-justify">
              c. <strong>No Assignment of Rights:</strong> This license does not
              transfer or assign any ownership rights in the Apps or any
              intellectual property rights therein. You acknowledge and agree
              that See Sight Tours Inc retains all rights, title, and interest
              in and to the Apps and any related materials.
            </p>

            <p className="text-base text-justify">
              d. <strong>Use of Trademarks:</strong> The See Sight Tours Inc
              name, logo, and other trademarks, service marks, and trade names
              used in connection with the Apps are the property of See Sight
              Tours Inc and may not be used without the prior written consent of
              See Sight Tours Inc.
            </p>
            <p className="text-base text-justify">
              e. <strong> User Content: </strong> Any content, materials, or
              information that you upload, transmit, or otherwise make available
              through the Apps ("User Content") remains your property. However,
              by uploading User Content to the Apps, you grant See Sight Tours
              Inc a worldwide, royalty-free, non-exclusive, irrevocable,
              sublicensable license to use, reproduce, modify, adapt, publish,
              translate, distribute, and display such User Content in connection
              with the operation of the Apps.
            </p>
            <p className="text-base text-justify">
              f. <strong> Copyright Infringement: </strong> See Sight Tours Inc
              respects the intellectual property rights of others and expects
              Users to do the same. If you believe that your copyright-protected
              work has been used or copied in a way that constitutes copyright
              infringement and is accessible via the Apps, please submit a DMCA
              takedown notice to our designated agent.
            </p>
            <p className="text-base text-justify">
              g. <strong> Reservation of Rights: </strong> See Sight Tours Inc
              reserves all rights not expressly granted to you under this
              Agreement. Any unauthorized use of the Apps or violation of these
              intellectual property rights may result in the termination of your
              license and may subject you to legal consequences.
            </p>
          </div>

          <div className="flex flex-col gap-3  mt-6">
            <h2 className="text-[16px] md:text-[18px]  font-bold">
              4. Privacy
            </h2>
            <p className="text-base text-justify">
              a. <strong> Collection of Information:</strong> See Sight Tours
              Inc may collect certain information from or about you when you use
              the See Sight Tours and See Sight Tours Goat App mobile
              applications (collectively, the “See Sight Tours Platform”). This
              may include personal information such as your name, email address,
              phone number, location data, and any other information you provide
              when using the Apps.
            </p>
            <p className="text-base text-justify">
              b. <strong>Use of Information: </strong> See Sight Tours Inc may
              use the information collected from you for various purposes,
              including but not limited to
            </p>
            <div className="ml-5">
              <p className="text-base text-justify">
                i. Providing and improving the functionality of the Apps.
              </p>
              <p className="text-base text-justify">
                ii. Customizing your user experience and providing personalized
                content and recommendations.
              </p>
              <p className="text-base text-justify">
                iii. Communicating with you, including responding to your
                inquiries and providing customer support.
              </p>
              <p className="text-base text-justify">
                iv. Analyzing usage trends and preferences to enhance the
                performance and usability of the Apps.
              </p>
              <p className="text-base text-justify">
                v. Detecting, preventing, and addressing technical issues or
                security vulnerabilities.
              </p>
            </div>
            <p className="text-base text-justify">
              c. <strong>Third-Party Services:</strong> The Apps may integrate
              with or contain links to third-party services, websites, or
              content. See Sight Tours Inc is not responsible for the privacy
              practices or content of such third parties. Your interactions with
              these third parties are governed by their respective privacy
              policies, and we encourage you to review them before providing any
              personal information.
            </p>

            <p className="text-base text-justify">
              d. <strong>Location Information:</strong> The Apps may collect and
              use your location data to provide location-based services, such as
              displaying nearby attractions or providing directions. You can
              enable or disable location services in your device settings at any
              time, but certain features of the Apps may be unavailable if you
              choose to disable location services.
            </p>
            <p className="text-base text-justify">
              e. <strong> Data Security: </strong> See Sight Tours Inc takes
              reasonable measures to protect the security and integrity of your
              personal information. However, no data transmission over the
              internet or method of electronic storage is completely secure, and
              we cannot guarantee the absolute security of your information.
            </p>
            <p className="text-base text-justify">
              f. <strong> Data Retention: </strong>See Sight Tours Inc retains
              your personal information for as long as necessary to fulfill the
              purposes for which it was collected, unless a longer retention
              period is required or permitted by law.
            </p>
            <p className="text-base text-justify">
              g. <strong> Children's Privacy: </strong> The Apps are not
              intended for use by children under the age of 16. See Sight Tours
              Inc does not knowingly collect personal information from children
              under the age of 16. If you are a parent or guardian and believe
              that your child has provided personal information to us, please
              contact us immediately so that we can take appropriate action.
            </p>
            <p className="text-base text-justify">
              h. <strong> Updates to Privacy Policy: </strong> See Sight Tours
              Inc reserves the right to modify or update this Privacy Policy at
              any time. Any changes to the Privacy Policy will be effective
              immediately upon posting of the revised policy. Your continued use
              of the Apps after any such changes constitutes acceptance of the
              updated Privacy Policy.
            </p>
            <p className="text-base text-justify">
              i. <strong> Contact Information: </strong> If you have any
              questions or concerns about this Privacy Policy or our privacy
              practices, please contact us at info@see sight tours.com.
            </p>
          </div>
          <div className="flex flex-col gap-3  mt-6">
            <h2 className="text-[16px] md:text-[18px]  font-bold">
              5. Termination
            </h2>
            <p className="text-base text-justify">
              a. <strong> Termination by User:</strong> You may terminate this
              Agreement at any time by ceasing all use of the See Sight Tours
              and See Sight Tours Goat App mobile applications (collectively,
              the “See Sight Tours Platform”) and deleting all copies of the
              Apps from your devices.
            </p>
            <p className="text-base text-justify">
              b. <strong>Termination by See Sight Tours Inc: </strong> See Sight
              Tours Inc reserves the right to terminate this Agreement at any
              time without notice if you breach any provision of this Agreement.
              Upon termination, your license to use the Apps shall immediately
              cease, and you must cease all use of the Apps and delete all
              copies thereof from your devices.
            </p>

            <p className="text-base text-justify">
              c. <strong>Effect of Termination:</strong> Upon termination of
              this Agreement, all rights and licenses granted to you under this
              Agreement will immediately terminate, and you must cease all use
              of the Apps and delete all copies thereof from your devices.
              Termination of this Agreement shall not affect any rights or
              obligations that have accrued prior to termination.
            </p>

            <p className="text-base text-justify">
              d. <strong>Survival:</strong> Sections 3 (Intellectual Property
              Rights), 4 (Privacy), 6 (Disclaimer of Warranties), 7 (Limitation
              of Liability), 8 (Governing Law), 9 (Changes to Agreement), and
              this Section 5 (Termination) shall survive any termination or
              expiration of this Agreement.
            </p>
            <p className="text-base text-justify">
              e. <strong> No Obligation to Retain Data: </strong> See Sight
              Tours Inc shall have no obligation to retain any data or
              information associated with your use of the Apps following
              termination of this Agreement. You are solely responsible for
              backing up any data or information you wish to retain prior to
              termination.
            </p>
            <p className="text-base text-justify">
              f. <strong> No Refunds: </strong>In the event of termination by
              See Sight Tours Inc due to your breach of this Agreement, you will
              not be entitled to any refunds or compensation, and See Sight
              Tours Inc shall have no liability to you for any losses or damages
              arising from such termination.
            </p>
            <p className="text-base text-justify">
              g. <strong> Right to Disable Access: </strong> See Sight Tours Inc
              reserves the right to disable or suspend your access to the Apps
              at any time without notice if See Sight Tours Inc believes, in its
              sole discretion, that such action is necessary to protect the
              integrity or security of the Apps or to prevent unauthorized
              access or use.
            </p>
          </div>
          <div className="flex flex-col gap-3  mt-6">
            <h2 className="text-[16px] md:text-[18px]  font-bold">
              6. Disclaimer of Warranties
            </h2>
            <p className="text-base text-justify">
              a. <strong> As Is Basis:</strong> THE SEE SIGHT TOURS AND SEE
              SIGHT TOURS GOAT APP MOBILE APPLICATIONS (COLLECTIVELY REFERRED TO
              AS THE "SEE SIGHT TOURS PLATFORM") ARE PROVIDED "AS IS" AND "AS
              AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, WHETHER EXPRESS OR
              IMPLIED. TO THE FULLEST EXTENT PERMITTED BY LAW, SEE SIGHT TOURS
              INC DISCLAIMS ALL WARRANTIES, INCLUDING BUT NOT LIMITED TO
              MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND
              NON-INFRINGEMENT.
            </p>
            <p className="text-base text-justify">
              b. <strong> No Warranty of Accuracy or Completeness: </strong> SEE
              SIGHT TOURS INC DOES NOT WARRANT OR MAKE ANY REPRESENTATIONS
              REGARDING THE ACCURACY, RELIABILITY, OR COMPLETENESS OF THE
              INFORMATION, CONTENT, FEATURES, OR FUNCTIONALITY PROVIDED BY THE
              APPS. SEE SIGHT TOURS INC DOES NOT WARRANT THAT THE APPS WILL MEET
              YOUR REQUIREMENTS, BE UNINTERRUPTED, TIMELY, SECURE, OR
              ERROR-FREE, OR THAT ANY DEFECTS OR ERRORS IN THE APPS WILL BE
              CORRECTED.
            </p>

            <p className="text-base text-justify">
              c. <strong> No Warranty of Compatibility:</strong> SEE SIGHT TOURS
              INC DOES NOT WARRANT THAT THE APPS WILL BE COMPATIBLE WITH ALL
              DEVICES, OPERATING SYSTEMS, OR BROWSERS, OR THAT THE APPS WILL BE
              ACCESSIBLE FROM ALL LOCATIONS. YOU ACKNOWLEDGE AND AGREE THAT YOUR
              USE OF THE APPS MAY BE SUBJECT TO LIMITATIONS, DELAYS, AND OTHER
              ISSUES INHERENT IN THE USE OF THE INTERNET AND ELECTRONIC
              COMMUNICATIONS.
            </p>

            <p className="text-base text-justify">
              d. <strong>Third-Party Content and Services:</strong> SEE SIGHT
              TOURS INC DOES NOT ENDORSE, WARRANT, OR GUARANTEE THE ACCURACY,
              RELIABILITY, OR QUALITY OF ANY CONTENT, MATERIALS, PRODUCTS, OR
              SERVICES PROVIDED BY THIRD PARTIES THROUGH OR IN CONNECTION WITH
              THE APPS. ANY DEALINGS YOU HAVE WITH THIRD PARTIES ARE SOLELY
              BETWEEN YOU AND SUCH THIRD PARTIES, AND SEE SIGHT TOURS INC SHALL
              HAVE NO LIABILITY FOR ANY DAMAGES OR LOSSES ARISING FROM SUCH
              DEALINGS.
            </p>
            <p className="text-base text-justify">
              e. <strong> No Legal, Financial, or Medical Advice: </strong> THE
              CONTENT AND INFORMATION PROVIDED BY THE APPS ARE FOR GENERAL
              INFORMATIONAL PURPOSES ONLY AND DO NOT CONSTITUTE LEGAL,
              FINANCIAL, OR MEDICAL ADVICE. YOU SHOULD CONSULT WITH APPROPRIATE
              PROFESSIONALS BEFORE MAKING ANY DECISIONS BASED ON SUCH
              INFORMATION.
            </p>
            <p className="text-base text-justify">
              f. <strong> No Guarantee of Results: </strong>SEE SIGHT TOURS INC
              DOES NOT GUARANTEE ANY SPECIFIC RESULTS FROM YOUR USE OF THE APPS.
              YOUR USE OF THE APPS IS AT YOUR OWN RISK, AND SEE SIGHT TOURS INC
              SHALL NOT BE LIABLE FOR ANY DAMAGES OR LOSSES ARISING FROM YOUR
              RELIANCE ON OR USE OF THE APPS.
            </p>
          </div>
          <div className="flex flex-col gap-3  mt-6">
            <h2 className="text-[16px] md:text-[18px]  font-bold">
              7. Limitation of Liability
            </h2>
            <p className="text-base text-justify">
              a. <strong> Exclusion of Certain Damages:</strong> See Sight Tours
              Inc, its affiliates, licensors, and service providers, and their
              respective officers, directors, employees, agents, successors, and
              assigns (collectively referred to as "See Sight Tours Parties")
              shall not be liable for any indirect, incidental, special,
              consequential, or punitive damages, including but not limited to
              loss of profits, revenue, data, or goodwill, arising out of or
              related to your use of the See Sight Tours and See Sight Tours
              Goat App mobile applications (collectively referred to as the "See
              Sight Tours Platform"), whether based on warranty, contract, tort
              (including negligence), or any other legal theory, even if a See
              Sight Tours Party has been advised of the possibility of such
              damages.
            </p>
            <p className="text-base text-justify">
              b. <strong> Limitation of Direct Damages: </strong>In no event
              shall the aggregate liability of the See Sight Tours Parties
              arising out of or related to your use of the Apps exceed the
              greater of
            </p>
            <div className="ml-5">
              <p className="text-base text-justify">
                i. the amount paid by you, if any, for access to or use of the
                Apps during the twelve (12) months prior to the event giving
                rise to liability, or
              </p>
              <p className="text-base text-justify">
                ii. one hundred U.S. dollars ($100.00).
              </p>
            </div>
            <p className="text-base text-justify">
              c. <strong> Scope of Limitations:</strong> The limitations and
              exclusions of liability set forth in this Agreement apply even if
              any remedy fails of its essential purpose. Some jurisdictions do
              not allow the exclusion or limitation of incidental or
              consequential damages, so the above limitations may not apply to
              you to the extent prohibited by applicable law.
            </p>

            <p className="text-base text-justify">
              d. <strong>Basis of Allocation of Risk:</strong> You acknowledge
              and agree that the limitations and exclusions of liability set
              forth in this Agreement are reasonable and fair, and that your use
              of the Apps reflects your acceptance of this allocation of risk.
              You agree that the limitations and exclusions of liability set
              forth in this Agreement are essential elements of the basis of the
              bargain between you and See Sight Tours Inc, and that See Sight
              Tours Inc would not provide the Apps to you without such
              limitations and exclusions.
            </p>
          </div>
          <div className="flex flex-col gap-3  mt-6">
            <h2 className="text-[16px] md:text-[18px]  font-bold">
              8. Governing Law
            </h2>
            <p className="text-base text-justify">
              a. <strong> Applicable Law:</strong> This Agreement and your use
              of the See Sight Tours and See Sight Tours Goat App mobile
              applications (collectively referred to as the "See Sight Tours
              Platform") shall be governed by and construed in accordance with
              the laws of the State of Delaware, United States, without regard
              to its conflict of law provisions.
            </p>
            <p className="text-base text-justify">
              b. <strong> Jurisdiction: </strong>Any dispute, controversy, or
              claim arising out of or relating to this Agreement or your use of
              the Apps shall be resolved exclusively by the state and federal
              courts located in Delaware, United States. You hereby consent to
              the jurisdiction and venue of such courts and waive any objection
              to such jurisdiction or venue on grounds of forum non conveniens
              or otherwise.
            </p>

            <p className="text-base text-justify">
              c. <strong> Waiver of Jury Trial:</strong> You hereby waive any
              right to a jury trial in any proceeding arising out of or relating
              to this Agreement or your use of the Apps. You acknowledge that a
              trial by jury is a fundamental constitutional right, and you
              voluntarily and knowingly waive that right.
            </p>

            <p className="text-base text-justify">
              d. <strong>Injunctive Relief:</strong> Notwithstanding anything to
              the contrary in this Agreement, See Sight Tours Inc may seek
              injunctive or other equitable relief in any court of competent
              jurisdiction to enforce its rights under this Agreement or to
              prevent any breach or threatened breach of this Agreement.
            </p>

            <p className="text-base text-justify">
              e. <strong>Class Action Waiver:</strong> You agree that any
              dispute resolution proceedings will be conducted only on an
              individual basis and not in a class, consolidated, or
              representative action. You waive any right to participate in or be
              represented by counsel in any class, consolidated, or
              representative proceeding.
            </p>
          </div>
          <div className="flex flex-col gap-3  mt-6">
            <h2 className="text-[16px] md:text-[18px]  font-bold">
              9. Changes to Agreement
            </h2>
            <p className="text-base text-justify">
              a. <strong> Modification of Agreement:</strong> See Sight Tours
              Inc reserves the right to modify or update this End User License
              Agreement (EULA) at any time by posting the revised terms on the
              See Sight Tours and See Sight Tours Goat App mobile applications
              (collectively referred as the “See Sight Tours Platform”). Your
              continued use of the Apps after any such changes constitutes
              acceptance of the updated terms and conditions.
            </p>
            <p className="text-base text-justify">
              b. <strong> Notice of Changes: </strong>See Sight Tours Inc may
              provide notice of material changes to this Agreement by email or
              by posting a notice on the Apps. You agree to review this
              Agreement periodically to stay informed of any updates or
              modifications.
            </p>

            <p className="text-base text-justify">
              c. <strong> Effective Date of Changes:</strong> Any changes to
              this Agreement will be effective immediately upon posting or as
              otherwise specified in the notice of changes. Your continued use
              of the Apps after the effective date of the changes constitutes
              acceptance of the updated terms and conditions.
            </p>

            <p className="text-base text-justify">
              d. <strong>Right to Reject Changes:</strong> If you do not agree
              to any changes to this Agreement, you must cease all use of the
              Apps and delete all copies thereof from your devices. Your
              continued use of the Apps after the effective date of the changes
              shall constitute acceptance of the updated terms and conditions.
            </p>

            <p className="text-base text-justify">
              e. <strong>No Retroactive Application:</strong> Changes to this
              Agreement will not apply retroactively to disputes or events
              arising before the effective date of the changes, unless otherwise
              specified in the notice of changes.
            </p>
            <p className="text-base text-justify">
              f. <strong> Contact Information:</strong> Changes to this
              Agreement will not apply retroactively to disputes or events
              arising before the effective date of the changes, unless otherwise
              specified in the notice of changes.
            </p>
          </div>
          <div className="flex flex-col gap-3  mt-6">
            <h2 className="text-[16px] md:text-[18px]  font-bold">
              10. Copyright and DMCA Compliance
            </h2>
            <p className="text-base text-justify">
              a. <strong> Copyright Ownership:</strong> The Apps and all
              content, features, and functionality thereof are owned by See
              Sight Tours Inc and are protected by copyright laws and
              international treaties. You acknowledge and agree that See Sight
              Tours Inc retains all rights, title, and interest in and to the
              Apps and any related materials.
            </p>
            <p className="text-base text-justify">
              b. <strong> DMCA Policy: </strong>See Sight Tours Inc respects the
              intellectual property rights of others and expects Users to do the
              same. If you believe that your copyright-protected work has been
              used or copied in a way that constitutes copyright infringement
              and is accessible via the Apps, please submit a DMCA takedown
              notice to our designated agent:
              <p className="mt-4">
                Designated Agent: [Adrian White] [adrian@tripshpherd.com]
              </p>
            </p>

            <p className="text-base text-justify">
              c. <strong> Notice and Takedown Procedure:</strong> See Sight
              Tours Inc will respond to valid DMCA takedown notices in
              accordance with the procedures outlined in the Digital Millennium
              Copyright Act (DMCA). Upon receipt of a valid notice, See Sight
              Tours Inc may remove or disable access to the allegedly infringing
              material and notify the User who uploaded the content.
            </p>

            <p className="text-base text-justify">
              d. <strong>Counter Notification:</strong> If you believe that your
              content was removed or disabled as a result of a mistake or
              misidentification, you may submit a counter notification to See
              Sight Tours Inc's designated agent. See Sight Tours Inc will
              review the counter notification and may restore the removed
              material unless the copyright holder files a lawsuit seeking a
              court order to prevent the restoration.
            </p>

            <p className="text-base text-justify">
              e. <strong>Repeat Infringers:</strong> See Sight Tours Inc
              reserves the right to terminate User accounts or access to the
              Apps of Users who are repeat infringers of copyright.
            </p>
            <p className="text-base text-justify">
              f. <strong> No Liability for Third-Party Content:</strong> See
              Sight Tours Inc is not responsible for monitoring or reviewing
              User-generated content uploaded to the Apps. However, See Sight
              Tours Inc may remove or disable access to content upon receipt of
              a valid DMCA takedown notice.
            </p>
            <p className="text-base text-justify">
              g. <strong>Indemnification:</strong> You agree to indemnify,
              defend, and hold harmless See Sight Tours Inc from any claims,
              damages, liabilities, costs, or expenses arising out of or related
              to your violation of copyright laws or your breach of this
              Agreement.
            </p>
          </div>
          <div className="flex flex-col gap-3  mt-6">
            <h2 className="text-[16px] md:text-[18px] font-bold">
              11. Entire Agreement
            </h2>
            <p className="text-base text-justify">
              a. <strong> Understanding of Terms:</strong> This End User License
              Agreement (EULA), together with any additional terms and
              conditions incorporated herein by reference, constitutes the
              entire agreement between you and See Sight Tours Inc regarding
              your use of the See Sight Tours and See Sight Tours Goat App
              mobile applications (collectively referred to as the "See Sight
              Tours Platform"), and supersedes all prior or contemporaneous
              communications, agreements, and understandings, whether oral or
              written, between you and See Sight Tours Inc.
            </p>
            <p className="text-base text-justify">
              b. <strong> Amendment and Waiver: </strong>Any modification or
              waiver of any provision of this Agreement must be in writing and
              signed by an authorized representative of See Sight Tours Inc. The
              failure of See Sight Tours Inc to exercise or enforce any right or
              provision of this Agreement shall not constitute a waiver of such
              right or provision.
            </p>

            <p className="text-base text-justify">
              c. <strong> Severability:</strong> If any provision of this
              Agreement is held to be invalid, illegal, or unenforceable by a
              court of competent jurisdiction, such provision shall be deemed
              modified to the extent necessary to make it valid, legal, and
              enforceable, and the validity, legality, and enforceability of the
              remaining provisions of this Agreement shall not be affected or
              impaired thereby.
            </p>

            <p className="text-base text-justify">
              d. <strong>Assignment:</strong> You may not assign or transfer any
              of your rights or obligations under this Agreement without the
              prior written consent of See Sight Tours Inc. See Sight Tours Inc
              may assign or transfer any of its rights or obligations under this
              Agreement without restriction.
            </p>

            <p className="text-base text-justify">
              e. <strong>Headings: </strong> The section headings in this
              Agreement are for convenience only and shall not affect the
              construction or interpretation of any provision.
            </p>
            <p className="text-base text-justify">
              f. <strong> Survival:</strong> Any provisions of this Agreement
              that by their nature should survive termination or expiration,
              including but not limited to Sections 3 (Intellectual Property
              Rights), 4 (Privacy), 5 (Termination), 6 (Disclaimer of
              Warranties), 7 (Limitation of Liability), 8 (Governing Law), 9
              (Changes to Agreement), 10 (Copyright & DMCA Compliance) and this
              Section 11 (Entire Agreement), shall survive any termination or
              expiration of this Agreement.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default LicenseAgreement;
